<template>
 <div class="rechargeable">
    <div  style="overflow: auto; height: 88%;">
        <!-- 下拉刷新组件 -->
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <!-- 列表组件 -->
      <van-list v-model="loading" :finished="finished" :finished-text="bomTitle" @load="onLoad" :offset="20">
      <div class="list" v-if="list.length > 0">
      <div class="list_item b-b" v-for="(item, index) in list" :key="index">
      <van-image v-if="item.rechargeType == 3" class="typeIcon" :src="require('@/assets/img/bank.png')" ></van-image>
      <van-image v-if="item.rechargeType == 2" class="typeIcon" :src="require('@/assets/img/zhifubao.png')" ></van-image>
      <van-image v-if="item.rechargeType == 1" class="typeIcon" :src="require('@/assets/img/weixing.png')" ></van-image>
      <div class="jiao" v-if="item.examineStatus == 0"><van-image :src="require('@/assets/img/wait_pass.png')" width="5rem"  height="1.5rem"></van-image></div>
      <div class="jiao" v-if="item.examineStatus == 1"><van-image :src="require('@/assets/img/yes_pass.png')" width="5rem" height="1.5rem"></van-image></div>
      <div class="jiao" v-if="item.examineStatus == 2"><van-image :src="require('@/assets/img/not_pass.png')" width="5rem" height="1.5rem"></van-image></div>
      <div class="item_l">
        <div class="text1 mb20" v-if="item.rechargeType == 1">微信</div>
        <div class="text1 mb20" v-if="item.rechargeType == 2">支付宝</div>
        <div class="text1 mb20" v-if="item.rechargeType == 3">银行卡</div>
        <div class="text2">{{item.createTime}}</div>
      </div>
      <div class="item_r">
        <div class="text1 mb20"> +{{item.rechargeMoney}}</div>
        <div class="text2">余额: {{item.balance}}</div>
      </div>
    </div>
  </div>
  <div class="no_data" v-else>
    <div>
      <!-- <van-image :src="require('@/assets/img/no_data.png')" class="empty"/>
      <div style="text-align: center;" class="emptyText">暂无数据</div> -->
      <van-empty description="暂无数据" />
    </div>
  </div>
</van-list>
  </van-pull-refresh>
   </div>
<van-popup v-model="show" bind:close="onClose"  catchtouchmove='true' position="bottom" round closeable>
  <div class="alert">
    <div class="title">充值</div>
    <div class="code">充值编码:{{code}}</div>
    <div class="info"><i style="font-weight:700">温馨提示:</i>充值转账时请在转账订单备注栏备注昵称➕充值编码，比如：张三 123456 。若因未备注编码造成损失由本人承担</div>
    <div class="alert_item">
      <div class="alert_item_l">充值方式</div>
      <div class="alert_item_r df">
        <div class="alert_item_type" :class="{'select': index == (selectTypeFlag-1)}"  v-for="(item, index) in typeList" :key="index"  @click="tabclick(index)"   >{{item}}</div>
      </div>
    </div>
    <div v-if="selectTypeFlag==3" class="alert_item">
      <div class="alert_item_l">银行名称</div>
      <div class="alert_item_r">{{tabData.bankName}}</div>
    </div>

    <div v-if="selectTypeFlag == 3">
      <div class="alert_item">
        <div class="alert_item_l">名字</div>
        <div class="alert_item_r">{{tabData.userName}}</div>
      </div>
      <div class="alert_item">
        <div class="alert_item_l">账号</div>
        <div class="alert_item_r">{{tabData.account}}</div>
      </div>
    </div>
    <div class="pay" v-else>
      <div class="pay_l">
        <div class="alert_item">
          <div class="alert_item_l">名字</div>
          <div class="alert_item_r">{{tabData.userName}}</div>
        </div>
        <div class="alert_item">
          <div class="alert_item_l">账号</div>
          <div class="alert_item_r">{{tabData.account}}</div>
        </div>
      </div>
      <div class="pay_r">
        <van-image :src="tabData.pic"    mode=""/>
      </div>
    </div>
    <van-field   class="alert_item" v-model="money" label="充值金额" type="digit"  maxlength="8"  placeholder="请输入金额"  input-align="right"> <template slot="button">元</template></van-field>
    <div class="chonglist">
      <div class="item"  :class= "{ 'select':index == chongFlag}"  v-for="(item, index) in moneyList" :key="index"   @click="changeMoney(item,index)">{{item}}</div>
    </div>
    <van-field   class="alert_item" v-model="remark" label="充值备注"   maxlength="50"  placeholder="请填写备注"  input-align="right"/>
    <div class="alert_item">上传充值截图</div>
    <div class="imageBox">
      <van-uploader  :max-size="1024 * 1024*1.5" v-model="fileList" multiple :max-count="1">
        <van-image  v-if="imagesArr.length > 0" class="image" :src="fileList[0]" mode=""/>
          <div v-else class="add" ><div class="jia">+</div> 点击上传</div>
      </van-uploader>
    </div>
    <div class="button" @click="release">保存</div>
  </div>
</van-popup>
<BackButton @back="rechargeable" ><div class="recharge_but">我要充值</div></BackButton>
</div>
</template>

<script>
import { getRechargeList,getAccountInfo,addRecharge } from "@/api/recharge.js";


export default {
  name: "HomePage",
  data() {
    return {
      pageNum: 1,
      total: 0,
      code: 0,
      typeList: ['微信', '支付宝', '银行卡'],
      accountInfo: {},
      tabData: {},
      list: [],
      moneyList: [10000, 20000, 50000],
      selectFlag: 0,
      selectTypeFlag: 1,
      chongFlag: undefined,
      show: false,
      show1: false,
      imagesArr: {},
      remark: '',
      money: 0,
      fileList:[],
      isLoading: false, // 控制下拉刷新的加载状态
      loading: false, // 控制上拉加载的加载状态
      finished: false, // 是否已加载完全部数据
      bomTitle: '', // 上拉加载完成时的文本
      pageTotal: 0,
    };
  },

  mounted() {
    this.finished= true
    this.informPort(true); //列表数据接口
    this.queryAccountInfo();
    let user = this.$store.state.user.userInfo;
    this.code = user.id
    },

  methods: {
    rechargeable(){
      console.log(123);
      this.show =true
    },
    afterRead(file){
      this.fileList = []
      this.fileList.push(file.content);
    },
        // 获取列表数据
    informPort(flag) {
      getRechargeList(this.pageNum).then(res => {
        console.log(res)
        if (res.code == 200 && res.rows) {
          console.log(res)
          let dataList = res.rows
          if (dataList && dataList.length) {
            if (flag) {
              this.list = dataList
            } else {
              this.list = [...this.list, ...dataList]
            }
          }
          this.total = res.total
          this.loading = false
          this.finished = false
          if (this.list.length >= this.total) {
            this.bomTitle = '到底了~ ' + '共计' + res.total + '条'
            this.finished = true
          } else {
            this.pageNum += 1
            this.bomTitle = ''
          }
        }
      })
    },
     // 下拉刷新
    onRefresh() {
      this.pageNum = 1
      this.finished = true
      this.loading = true
      this.list = []
      this.isLoading =true
      setTimeout(() => {
        this.isLoading = false // 结束下拉刷新的加载状态
        this.informPort(true) // 重新获取列表数据
        this.$toast.success('刷新成功')
      }, 300)
    },
    // 上拉加载
    onLoad() {
      this.informPort() 
      // 获取更多列表数据
      
    },
     queryAccountInfo(){
        getAccountInfo().then((res) => {
          console.log(res)
          if (res.code == 200) {
            this.accountInfo= res.data,
            this.tabData =res.data.weixinAccount
      }
    })
  },
   tabclick(index) {
      if(index == 0){
          this.tabData = this.accountInfo.weixinAccount,
          this.selectTypeFlag= index+1
      }
      if(index == 1){
        this.tabData= this.accountInfo.aliAccount,
        this.selectTypeFlag= index+1
    }
    if(index == 2){
       this.tabData= this.accountInfo.bankAccount,
        this.selectTypeFlag= index+1
    } 
  },
   changeMoney(item,index) {
      this.money = item
      this.chongFlag = index
    },
   release() {
    if(!this.money || this.money <= 0){
       this.$toast.fail('金额必须大于0')
        return;
    }
    if(this.money && this.money > 500000){
       this.$toast.fail('单次充值金额不能大于500000')
      return;
    }
    if(this.fileList.length <= 0){
       this.$toast.fail('请选择图片')
      return;
    }
    let formData = new FormData();
    formData.append("file", this.fileList[0].file);  // 照片文件
    formData.append("selectTypeFlag", this.selectTypeFlag); // 其他参数
    formData.append("money", this.money); // 其他参数
    formData.append("remark", this.remark); // 其他参数
    formData.append("sysType", 2); // 其他参数
    console.log(formData)
    addRecharge(formData).then((res) => {
      console.log(res)
        if (res.code == 200) {
          this.$toast.success('保存成功')
           this.pageNum = 1
           this.finished = true
           this.loading = true
            this.list = [],
            this.show =false,
            this.selectFlag = 0,
            this.selectTypeFlag = 1,
            this.chongFlag = -1,
            this.money = '',
            this.remark =''
          setTimeout(() => {
             this.isLoading = false // 结束下拉刷新的加载状态
             this.informPort(true) // 重新获取列表数据
          }, 300)      
      }else {
        this.$toast.fail(res.msg)
      }
    })

  },
  },
};
</script>

<style lang="less" scoped>
.rechargeable {
   width: 100%;
   height: 100vh;
   background: url(@/assets/img/team_bg.png) no-repeat left center;
   background-size: 100% 100%;
   overflow: hidden;
}

.list {
  padding-bottom: 16px;
}
.list .list_item {
  display: flex;
  align-items: center;
  padding: 20px 16px;
  position: relative;
  background-color: #516388;
  margin-top: 1px;
}
.list .list_item .jiao {
  position: absolute;
  right: 0;
  top: 0;
}
.list .list_item .jiao img {
  width: 64px;
  height: 18px;
}
.list .list_item .jiao .wait {
  width: 52px;
}
.list .list_item .jiao .not {
  width: 76px;
}
.list .list_item .typeIcon {
  width: 45px;
  height: 45px;
  margin-right: 8px;
}
.list .list_item .item_l,
.list .list_item .item_r {
  flex: 1;
}
.list .list_item .item_l .text1,
.list .list_item .item_r .text1 {
  font-size: 18px;
  color: #f8f8f8;
  line-height: 18px;
}
.list .list_item .item_l .text2,
.list .list_item .item_r .text2 {
  font-size: 16px;
  color: #f8f8f8;
  line-height: 16px;
  font-weight: 400;
}
.list .list_item .item_l .mb20,
.list .list_item .item_r .mb20 {
  margin-bottom: 8px;
}
.list .list_item .item_r {
  text-align: right;
}
.list .list_item .item_r .money {
  text-align: right;
  position: absolute;
  right: 20px;
  top: 50%;
  font-size: 20px;
  color: #0278EE;
  font-weight: 400;
  transform: translateY(-50%);
}
 

.pay {
  display: flex;

  .pay_l {
    flex: 1;
  }

  .pay_r {
    width: 96px;
    height: 96px;
    margin: 0 8px
  }

  image {
    width: 100%;
    height: 100%;
  }
}

.alertImg {
  width: 600rpx;
  height: 800rpx;
}
.no_data {
  margin-top: 10%;
  font-weight: 700;
}
.recharge_but {
    color: #fff;
    font-weight: 700;
    background: url(@/assets/img/float_btn.png) no-repeat left center;
    background-size: 100% 100%;
    padding: 5px;
    border-radius: 10px;
}
.alert {
  margin: 12px 0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #fff;
  line-height: 16px;
}
.alert .title {
  font-size: 20px;
  color: #fff;
  text-align: center;
  line-height: 20px;
  font-weight: 700;
}
.alert .code {
  font-size: 15px;
  color: #FF4800;
  text-align: center;
  font-weight: 400;
  margin-top: 1%;
}  
.alert .info {
    padding: 10px 16px;
    width: 95%;
    background: #FFFBE8;
    font-size: 14px;
    color: #FB7311;
    line-height: 20px;
    font-weight: 400;
    margin: 0 auto;
    margin-top: 3%;
    border-radius: 17px
}
::v-deep .van-field__label {
  color: #fff;
}
::v-deep .van-popup{
  background-color: #151925;
}
::v-deep .van-field__control {
  color: #fff;
}
.alert .chonglist {
  margin-top: 12px;
  display: flex;
}
.alert .chonglist .item {
  padding: 5px 11px;
  border: 1px solid #cccccc;
  border-radius: 8px;
  margin-left: 5%;
}
.alert .alert_item {
  display: flex;
  padding: 0 16px;
  align-items: center;
  justify-content: space-between;
  margin-top: 2%;
  height: 48px;
  background-color: #151925;
  font-size: 18px;
}
.alert .alert_item .df {
  display: flex;
}
.alert .alert_item .alert_item_type {
  padding: 5px 11px;
  border: 1px solid #cccccc;
  border-radius: 8px;
  margin-left: 12px;
  background-color: #9c9c9c;
}
.alert .alert_item input {
  flex: 1;
  margin-left: 8px;
  font-size: 16px;
  text-align: right;
  background-color: transparent;
  border: none;
  color: #d1c8c8;
}
.alert .alert_item .placeholder {
  font-size: 16px;
  font-weight: 400;
  color: #BBBBBB;
}
.alert .select {
  background-color: #6aabbb !important;
  border: 1px solid #6aabbb !important;
}
.alert .imageBox {
  display: flex;
  flex-wrap: wrap;
  padding: 0 16px;
}
.alert .imageBox .image {
  margin-right: 12px;
  margin-bottom: 12px;
  width: 84px;
  height: 84px;
  border-radius: 8px;
}
.alert .imageBox .add {
    margin-right: 12px;
    margin-bottom: 12px;
    width: 84px;
    height: 84px;
    border-radius: 18px;
    text-align: center;
    background: #D8D8D8;
    font-size: 14px;
    color: #666666;
    font-weight: 400;
}
.alert .imageBox .add .jia {
  padding-top: 19px;
  margin-bottom: 8px;
}
.alert .button {
    background: #FA4743;
    border-radius: 8px;
    color: #fff;
    height: 46px;
    line-height: 46px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    width: 50%;
    margin: 0 auto;
    margin-top: 12px;
}
.alert .btn {
  display: flex;
  justify-content: space-between;
}
.alert .btn button {
  width: 45%;
}
.alert .btn button:first-child {
  border: 2rpx solid #FA4743;
  background: #fff;
  color: #FA4743;
}
</style>